export interface Topic {
  id: string;
  title: string;
  subtitle: string;
  cover: string;
  intro: string;
  movieIds: string[];
  newsIds: string[];
}

export const topics: Topic[] = [
  {
    id: "topic-01",
    title: "秋夜治愈片单",
    subtitle: "适合一个人看完的六个温柔故事",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20autumn%20evening%20window%20seat%20with%20a%20warm%20lamp%2C%20a%20cup%20of%20tea%20and%20falling%20maple%20leaves%20outside%2C%20soft%20amber%20light%2C%20quiet%20cinematic%20still%2C%20no%20text&width=1200&height=700&seq=fl-topic-01&orientation=landscape",
    intro:
      "天气转凉之后，最适合看一些不着急的故事。这份片单里的作品都没有强烈的冲突，却都在某个瞬间让人放松下来——一碗面、一列火车、一间只在午夜开门的店。",
    movieIds: ["movie-10", "movie-02", "movie-03", "tv-07", "variety-07", "movie-07"],
    newsIds: ["news-09", "news-02", "news-03"],
  },
  {
    id: "topic-02",
    title: "迷雾追凶指南",
    subtitle: "把线索交给观众的五部高分悬疑",
    cover:
      "https://readdy.ai/api/search-image?query=Foggy%20harbor%20at%20night%20with%20a%20single%20sodium%20lamp%20and%20container%20cranes%2C%20cold%20grey%20mist%20and%20warm%20orange%20glow%2C%20mystery%20cinematic%20wide%20shot%2C%20no%20text&width=1200&height=700&seq=fl-topic-02&orientation=landscape",
    intro:
      "好的悬疑从不急着给答案。它们把线索藏进天气、道具和一句随口的对话里，让你在追剧的每一个晚上都保持警觉。",
    movieIds: ["movie-01", "movie-06", "tv-01", "tv-04", "tv-06", "tv-08"],
    newsIds: ["news-05", "news-01", "news-04", "news-08"],
  },
  {
    id: "topic-03",
    title: "华语新力量",
    subtitle: "正在改写类型规则的年轻创作者",
    cover:
      "https://readdy.ai/api/search-image?query=Film%20set%20at%20golden%20hour%20with%20young%20crew%20and%20camera%20equipment%20silhouettes%2C%20warm%20amber%20dust%20in%20the%20air%2C%20inspiring%20cinematic%20behind%20the%20scenes%20wide%20shot%2C%20no%20text&width=1200&height=700&seq=fl-topic-03&orientation=landscape",
    intro:
      "他们不追求宏大，也不急于讨好。这批年轻导演和创作者，正在用更具体的细节、更慢的节奏，重新定义华语影视的表达方式。",
    movieIds: ["movie-05", "movie-08", "tv-02", "tv-05", "tv-09", "tv-10"],
    newsIds: ["news-04", "news-06", "news-07", "news-12"],
  },
];